import {
  FieldTypes,
  textField1,
  dataSourcePrimaryKeys,
  systemDateField,
  hiddenFormField,
  SelectOptionFields,
  // byFields,
} from 'drapcode-constant';

const {
  createdBy,
  uuid,
  createdAt,
  isDeleted,
  updatedAt,
  file,
  password,
  large_text,
  object,
  belongsTo,
  date,
  updatedBy,
  version,
} = FieldTypes;

// console.log('byFields,systemDateField', byFields, systemDateField);
const collectionDefaultField = [uuid.id, ...systemDateField, version.id];
export const collectionDefaultFieldSortOrder = [
  { order: 1, field: uuid.id },
  { order: 2, field: createdAt.id },
  { order: 3, field: createdBy.id },
  { order: 4, field: updatedAt.id },
  { order: 5, field: updatedBy.id },
  { order: 6, field: version.id },
];

export const filterFieldsForForm = (fields) => {
  return fields.filter((field) => {
    return (
      !hiddenFormField.includes(field.type) && !dataSourcePrimaryKeys.includes(field.fieldName)
    );
  });
};
export const filterCollectionDefaultFields = (fields) => {
  const filteredDefaultCollectionFields =
    fields &&
    fields.filter((field) => {
      return (
        collectionDefaultField.includes(field.type) &&
        !dataSourcePrimaryKeys.includes(field.fieldName)
      );
    });

  const orderedFields = [];
  filteredDefaultCollectionFields &&
    filteredDefaultCollectionFields.map((defaultField) => {
      const order = collectionDefaultFieldSortOrder.find(
        (orderField) => orderField.field === defaultField.fieldName,
      ).order;
      orderedFields.push({ order, defaultField });
    });
  return orderedFields;
};

export const filterUserCreatedFieldsForItemList = (fields) => {
  return fields.filter((field) => {
    if (field.type === file.id && field.validation) {
      return field;
    } else {
      return (
        field.type !== createdBy.id &&
        field.type !== updatedBy.id &&
        field.type !== version.id &&
        field.type !== createdAt.id &&
        field.type !== updatedAt.id &&
        field.type !== uuid.id &&
        field.type !== isDeleted.id &&
        field.type !== password.id &&
        field.type !== large_text.id &&
        field.type !== file.id &&
        !dataSourcePrimaryKeys.includes(field.fieldName)
      );
    }
  });
};

export const filterFieldsOfCollection = (selectedCollection, extraFields = []) => {
  let selectedFields = selectedCollection ? selectedCollection.fields : [];
  selectedFields = selectedFields.filter((e) =>
    [...textField1, ...SelectOptionFields, belongsTo.id, date.id, ...extraFields].includes(e.type),
  );
  return selectedFields;
};

export const excludedFields = [
  'createdAt',
  'updatedAt',
  'createdBy',
  'uuid',
  'isDeleted',
  '_id',
  'updatedBy',
  'version',
  'id',
];
